import styled, { css } from 'styled-components';
import { FieldRoot, fieldBackgroundStatuses, applyEllipsis } from '@salutejs/plasma-core';
import { textXS } from '@salutejs/plasma-typo';
import { Placeholder } from './Placeholder';
import { Input } from './Input';
import { Content } from './Content';
export var Field = /*#__PURE__*/styled(FieldRoot).withConfig({
  componentId: "plasma-web-core__sc-4qkme5-0"
})(["", " --padding-left:", ";--padding-right:", ";", "{height:inherit;& > div{width:var(--field-content-size,1.5rem);height:var(--field-content-size,1.5rem);flex-basis:var(--field-content-size,1.5rem);}}", "{left:0;right:0;}", "{padding:var(--padding-default);&:not(:placeholder-shown){padding:", ";}}"], function (_ref) {
  var properties = _ref.properties;
  return properties;
}, function (_ref2) {
  var $isContentLeft = _ref2.$isContentLeft;
  return $isContentLeft ? 'var(--padding-content-left)' : null;
}, function (_ref3) {
  var $isContentRight = _ref3.$isContentRight;
  return $isContentRight ? 'var(--padding-content-right)' : null;
}, Content, Placeholder, Input, function (_ref4) {
  var withDefaultPadding = _ref4.withDefaultPadding;
  return withDefaultPadding ? 'var(--padding-default)' : 'var(--padding-input-not-placeholder-shown)';
});
export var FieldWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma-web-core__sc-4qkme5-1"
})(["position:relative;", ""], function (_ref5) {
  var status = _ref5.status;
  return status && css(["&::before{position:absolute;top:0;left:0;right:0;bottom:0;content:'';background:", ";opacity:0.3;border-radius:0.75rem;pointer-events:none;}"], fieldBackgroundStatuses[status]);
});
export var FieldHelpers = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma-web-core__sc-4qkme5-2"
})(["position:absolute;height:fit-content;width:100%;bottom:1.25rem;padding:0 1.5rem;box-sizing:border-box;display:flex;justify-content:space-between;"]);
/**
 * Вспомогательный текст снизу для поля ввода
 */

export var FieldHelper = /*#__PURE__*/styled.span.withConfig({
  componentId: "plasma-web-core__sc-4qkme5-3"
})(["", " margin:0;padding:0;", ";"], textXS, applyEllipsis);